/**
 * Which bundle is this?
 *
 * `vite.config.ts` replaces these two identifiers at build time with the
 * commit and the moment the bundle was produced. They exist because "the
 * browser is running old JavaScript" and "the server is running old code" look
 * identical from the outside, and the page had no way to say which — a deploy
 * was debugged twice from the wrong end for exactly that reason.
 *
 * Under `vitest` the `define` never runs, so the guards below matter: a test
 * importing this module gets `unknown` rather than a `ReferenceError`.
 */
declare const __BUILD_SHA__: string
declare const __BUILD_TIME__: string

export const BUILD_SHA: string =
  typeof __BUILD_SHA__ === 'string' && __BUILD_SHA__ ? __BUILD_SHA__ : 'unknown'

export const BUILD_TIME: string =
  typeof __BUILD_TIME__ === 'string' && __BUILD_TIME__ ? __BUILD_TIME__ : 'unknown'

/**
 * The one-line description for the header.
 *
 * `unknown` is rendered as `unknown`, never hidden. A build stamp that
 * disappears when it cannot be determined is worse than no stamp: its absence
 * reads as "this deployment is too old to have one", which is the very
 * question it was added to answer.
 */
export function buildLabel(): string {
  return `build ${BUILD_SHA}`
}

/** The `title` attribute: the full stamp, for when the short one is not enough. */
export function buildTitle(): string {
  return `Frontend bundle built from ${BUILD_SHA} at ${BUILD_TIME}. If this is not the commit you deployed, the browser is holding a cached index.html — hard-reload — or the build did not run.`
}
